import React from "react";
import { Button } from "@mui/material";

import { usePutdowns } from "../../../hooks/usePutdowns";
import { useGamePlayer } from "../../../hooks/useGamePlayer";
import { useDeclarer } from "../../../hooks/useDeclarer";
import { Card } from "../shared/Card";
import { useSelector } from "react-redux";
import { selectMyUserId, selectIAmDeclarer } from "../../../store/selectors";

export const PutdownPicker: React.FC = () => {
  const {
    putdowns,
    pickupCard,
    setPutdownsFinished,
    canBeFinished,
    requiredPutdownCount,
  } = usePutdowns();

  const activePlayerId = useSelector(selectMyUserId);
  const { loaded: gamePlayerLoaded } = useGamePlayer({
    playerId: activePlayerId,
  });
  const iAmDeclarer = useSelector(selectIAmDeclarer);

  const { loaded: declarerLoaded, name: declarerName } = useDeclarer();

  if (!gamePlayerLoaded || !declarerLoaded || putdowns === undefined) {
    return <div className="text-emerald-200 animate-pulse">Loading...</div>;
  }

  if (!iAmDeclarer) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for {declarerName} to put down cards...
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-2 text-white">Put Down Cards</h2>
      <p className="text-emerald-200 mb-6">
        Select {requiredPutdownCount} card{requiredPutdownCount !== 1 ? 's' : ''} from your hand to put down
      </p>
      <div className="flex flex-wrap gap-3 items-center justify-center mb-6">
        {putdowns.map((c) => (
          <div key={c.slug} className="relative group">
            <Card
              onClick={() => pickupCard(c)}
              slug={c.slug}
              enabled
            />
            <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
              ×
            </div>
          </div>
        ))}
        {putdowns.length === 0 && (
          <div className="text-emerald-300/60">Click cards in your hand to select them</div>
        )}
      </div>
      {canBeFinished && (
        <Button 
          onClick={setPutdownsFinished}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: '#059669',
            '&:hover': { backgroundColor: '#047857' },
            px: 4,
            py: 1.5,
          }}
        >
          Confirm Putdowns
        </Button>
      )}
    </div>
  );
};
